import { Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-banner-contact',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="container" style="margin-top: 103px;">
      <div class="box">
        <div class="content gird grid-cols-3">
          <div class="grid grid-cols-3" style="margin-left: -25px;">
            <div class="map grid grid-cols-2">
              <div class="img">
                <img
                  src="../../../../../assets/dark/Location-Icon.png"
                  width="70"
                  height="70"
                  alt=""
                />
              </div>
              <div class="content-child">
                <strong style="font-size: 24px;">Sukabumi</strong>
                <p style="font-size: 14px;">
                  Sukabumi Palabuhanratu 43364
                </p>
              </div>
            </div>
            <div class="map grid grid-cols-2">
              <div class="img">
                <img
                  src="../../../../../assets/dark/phone-call.png"
                  width="70"
                  height="70"
                  alt=""
                />
              </div>
              <div class="content-child" style="margin-left: 20px;">
                <strong style="font-size: 24px;">Call Us</strong>
                <p style="font-size: 14px;">
                  +6285724248746
                </p>
              </div>
            </div>
            <div class="map grid grid-cols-2">
              <div class="img">
                <img
                  src="../../../../../assets/dark/mail.png"
                  width="70"
                  height="70"
                  alt=""
                />
              </div>
              <div class="content-child" style="margin-left: 20px;">
                <strong style="font-size: 24px;">Mail Us</strong>
                <p style="font-size: 14px;">
                 freelancer9@gmail.com
                </p>
              </div>
            </div>
          </div>
          <div class="call"></div>
          <div class="email"></div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['banner-contact.component.scss'],
})
export class BannerContactComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
